<template>
  <div
    class="bg-muted-100 dark:bg-muted-900 relative flex min-h-screen w-full flex-col overflow-hidden px-4"
  >
    <div class="grow">
      <!-- HEADER -->
      <Header />
      <slot />
    </div>
    <footer class="sticky top-[100vh]">
      <div
        class="mx-auto flex w-full max-w-screen-xl flex-col space-y-4 p-4 md:flex-row md:items-center md:justify-center md:space-x-8 md:space-y-0"
      >
        <!-- Copyright text -->
        <span class="text-center text-sm text-gray-500 dark:text-gray-400">
          {{
            $t('page.copyright', {
              year: new Date().getFullYear(),
              safetynet: 'Safetynet Solutions',
            })
          }}
        </span>

        <!-- Language selector -->
        <div
          class="flex justify-center text-sm font-medium text-gray-500 dark:text-gray-400"
        >
          <LanguagePicker />
        </div>
      </div>
    </footer>
  </div>
</template>
<script setup>

</script>
